import * as S from './styles';
import IconButton from '@/components/atoms/IconButton';
import { IconeRemover } from '@/components/atoms/Icones/IconeRemover';
import { IconeAdicionar } from '@/components/atoms/Icones/IconeAdicionar';
import { useTheme } from 'styled-components';
import { ChangeEvent, CSSProperties, Dispatch, SetStateAction } from 'react';
import useBreakpoint from '@/hooks/useBreakpoint';
import Text from '@/components/atoms/Text';

export type QuantityVariant = 'surface' | 'soft' | 'ghost';

export type QuantityProps = {
  $variant: QuantityVariant;
  $orientation: 'vertical' | 'horizontal';
  $label?: string;
  $quantidade: number;
  $alterarQuantidade: Dispatch<SetStateAction<number>>;
  $callbackAlterarQuantidade?: () => void;
  $desabilitarAlteracaoQuantidade?: boolean;
  $styleControles?: CSSProperties;
};

export default function Quantity(props: QuantityProps) {
  const { breakpoint } = useBreakpoint();
  const {
    $label,
    $quantidade,
    $alterarQuantidade,
    $desabilitarAlteracaoQuantidade,
    $styleControles = {},
  } = props;
  const theme = useTheme();

  function lidarMudancaValor(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    if (!value) return $alterarQuantidade(0);
    if (value === '' || /^[0-9]*$/.test(value)) {
      $alterarQuantidade(parseInt(value));
    }
  }

  function mudarValorInputAposBlur() {
    $alterarQuantidade((quantidadeAnterior) => {
      if (quantidadeAnterior < 1) return 1;
      return quantidadeAnterior;
    });
  }

  return (
    <S.Container {...props}>
      {$label ? (
        <Text
          $size={breakpoint === 'mobile' ? 2 : 4}
          $highContrast={true}
          $text={$label}
          $align="left"
          $weight="semibold"
          $color="neutral"
        />
      ) : null}
      <S.ContainerControles style={$styleControles} {...props}>
        <IconButton
          $size={2}
          $state="default"
          $variant="surface"
          $color={$quantidade === 1 ? 'neutral' : 'accent'}
          $highContrast={true}
          $loading={false}
          $Icon={IconeRemover}
          $focusRing={false}
          $disabled={$quantidade === 1}
          $onClick={() =>
            $alterarQuantidade((quantidadeAnterior) => {
              if (quantidadeAnterior - 1 <= 0) return 1;
              return quantidadeAnterior - 1;
            })
          }
        />
        <S.Input
          $size={breakpoint === 'mobile' ? 3 : 4}
          value={$quantidade}
          onChange={lidarMudancaValor}
          onBlur={mudarValorInputAposBlur}
          {...props}
          readOnly={$desabilitarAlteracaoQuantidade}
        />
        <IconButton
          $size={2}
          $state="default"
          $variant="surface"
          $color="accent"
          $highContrast={false}
          $loading={false}
          $Icon={IconeAdicionar}
          $iconProps={{
            color: theme.colors.accent.accent['12'],
          }}
          $focusRing={false}
          $disabled={$desabilitarAlteracaoQuantidade}
          $onClick={() =>
            $alterarQuantidade((quantidadeAnterior) => quantidadeAnterior + 1)
          }
        />
      </S.ContainerControles>
    </S.Container>
  );
}
